module.exports = __webpack_public_path__ + "media/88.a5e4a778.mp3";